<template>
    <v-toolbar color="primary" fixed dark app :clipped-left="clipped">

        <v-toolbar-title>
          <v-toolbar-side-icon @click="handleDrawerToggle"></v-toolbar-side-icon>
        </v-toolbar-title>
          <img style="cursor:pointer;" @click="RedirectToHome" src="@/assets/logo-white.png" alt="Prwatech" />
        <v-spacer></v-spacer>
        <v-toolbar-items>
              <v-menu offset-y origin="center center" class="elelvation-1" :nudge-right="140" :nudge-bottom="14" transition="scale-transition">
                <v-btn icon flat slot="activator">
                  <v-badge color="red" overlap v-if="NotyCount && NotyCount > 0">
                    <span slot="badge">{{ NotyCount }}</span>
                    <v-icon medium>notifications</v-icon>
                  </v-badge>
                  <v-badge overlap v-else>
                    <v-icon medium>notifications</v-icon>
                  </v-badge>
                </v-btn>
                <notification-list @SetCount='SetCount'></notification-list>
              </v-menu>
            <v-btn icon @click="handleFullScreen()">
              <v-icon>fullscreen</v-icon>
            </v-btn>
            <v-btn icon large flat slot="activator">
              <v-avatar size="30px">
                <v-icon @click="handleLogout">logout</v-icon>
              </v-avatar>
            </v-btn>
        </v-toolbar-items>
    </v-toolbar>
</template>
<script>

import Util from "@/util"
import notificationList from '../views/Notification'

export default {
  components:{
      notificationList
  },
  name: "AppToolbar",
  data() {
    return {
        clipped  : true,
        NotyCount : 0
    }
  },
  computed:{
    computeLogo() {
      return "/static/m.png"
    },
  },
  methods: {
    RedirectToHome(){
       
        this.$router.push('/')
        this.$router.go()
    },
    SetCount(Count){
        this.NotyCount = Count
    },
    handleDrawerToggle() {
      this.$emit("side-icon-click")
    },
    handleFullScreen() {
      Util.toggleFullScreen()
    },
    handleLogout() {

      this.$http.get(`${this.$store.getters.GetProductionUrl}/login/logout`)
                .then(response =>{
                    
                    document.cookie = 'access_token' + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                    this.$router.push('/login')
                    this.$router.go()
                })
                .catch(err =>{
                    document.cookie = 'access_token' + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                    this.$router.push('/login')
                    this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error Logging Out","Color":"red","Close": false });
                })

    }
  }
}
</script>

<style scoped>
.activeClass{
  background: #d3d3d35c !important;
}
</style>
